<template>
  <div id="app">
    <HeaderTop @reload="reload"></HeaderTop>
    <router-view v-if="isRouterAlive"></router-view>
    <FooterBottom></FooterBottom>
  </div>
</template>
<script>
import HeaderTop from '@/views/Layout/Header.vue'
import FooterBottom from '@/views/Layout/Footer.vue'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  components: {
    HeaderTop,
    FooterBottom
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
  }
}
</script>
<style lang="less" scoped>
#app {
  font-family: Microsoft YaHei;
  overflow-x: hidden;
  background-color: #f7f4fc;
  padding-top: 80px;
}
</style>
